import { createContext } from 'react'
import { FormContextProps } from './contact-context-props'

export const FormContext = createContext<FormContextProps>({} as unknown as FormContextProps)